// Site Information
export const SITE = {
  name: "Lexi.tips",
  title: "Daily Racing Tips with LEXI",
  // Same sentence as the description meta tags in index.html (no betting-advice copy)
  description:
    "AI horse racing tips for every Australian race, three times: Early Mail up to 3 days out, Race Day tips and Late Mail minutes before the jump.",
  url: "https://lexi.tips",
  author: "Lexi.tips",
  themeColor: "#F30099",
} as const;

export const ERROR_404 = {
  title: "404",
  subtitle: "Page Not Found",
  description:
    "<strong>Oops! It seems like you've wandered into uncharted territory.</strong><br/> Let's get you back on track with LEXI's guidance.",
  button: "Return Home",
} as const;

// Social Media
export const SOCIAL = {
  twitter: "https://twitter.com/lexitips",
  facebook: "https://facebook.com/lexitips",
  instagram: "https://instagram.com/lexitips",
} as const;

// Navigation
export const NAVIGATION = {
  home: {
    path: "/home",
    label: "Home",
  },
  results: {
    path: "/results",
    label: "Results",
  },
} as const;

// API Endpoints
export const API = {
  baseUrl:
    import.meta.env.VITE_API_URL ||
    "https://australia-southeast1-staible-returns.cloudfunctions.net",
  // baseUrl:
  //   import.meta.env.VITE_API_URL ||
  //   "https://lexi-dev-lexi-1-mcdr62tc5a-ts.a.run.app",
  endpoints: {
    odds: "/odds",
    scores: "/scores",
    tips: "/tips",
    results: "/results",
  },
} as const;

// Time Periods
export const TIME_PERIODS = {
  day: "day",
  week: "week",
  month: "month",
  year: "year",
  allTime: "all_time",
} as const;

// Betting Types
export const BET_TYPES = {
  win: "win",
  place: "place",
  eachWay: "each_way",
} as const;

// Status Messages
export const STATUS = {
  loading: "Loading...",
  error: "An error occurred. Please try again.",
  noData: "No data available.",
  success: "Operation completed successfully.",
} as const;

// Form Validation
export const VALIDATION = {
  required: "This field is required",
  email: "Please enter a valid email address",
  password: {
    min: "Password must be at least 8 characters",
    match: "Passwords do not match",
  },
} as const;

export const DISCLAIMER = {
  disclaimer:
    "<strong>Lexi.tips</strong> is a <strong>tipping information service</strong> and <strong>does not accept or place bets</strong>. We are not a bookmaker or wagering operator. All tips and analysis are for recreational and entertainment purposes only. If you need assistance with gambling-related issues, contact <strong>1800 858 858</strong> or your local gambling support service.",
} as const;

// Date Formats
export const DATE_FORMATS = {
  display: "EEE, MMM d, yyyy",
  api: "yyyy-MM-dd",
  time: "h:mm a",
  full: "EEE, MMM d, yyyy h:mm a",
} as const;

// Analytics Events
export const ANALYTICS = {
  events: {
    login: "user_login",
    signup: "user_signup",
    viewTip: "view_tip",
    placeBet: "place_bet",
    viewResults: "view_results",
  },
} as const;

// Error Messages
export const ERRORS = {
  auth: {
    invalidCredentials: "Invalid email or password",
    sessionExpired: "Your session has expired. Please log in again.",
    unauthorized: "You are not authorized to access this resource.",
  },
  api: {
    network: "Network error. Please check your connection.",
    server: "Server error. Please try again later.",
    notFound: "The requested resource was not found.",
  },
} as const;

// UI Constants
export const UI = {
  maxWidth: "max-w-4xl",
  padding: "px-4",
  spacing: {
    xs: "space-y-2",
    sm: "space-y-4",
    md: "space-y-6",
    lg: "space-y-8",
  },
  colors: {
    primary: "#F0A7D6",
    secondary: "#3D3838",
    success: "#10B981",
    error: "#EF4444",
    warning: "#F59E0B",
  },
} as const;

// Cache Keys
export const CACHE_KEYS = {
  tips: "tips",
  results: "results",
  userProfile: "user-profile",
  settings: "user-settings",
} as const;

// Local Storage Keys
export const STORAGE_KEYS = {
  token: "auth-token",
  user: "user-data",
  theme: "color-theme",
  preferences: "user-preferences",
} as const;
